import { render } from "./CommandsList.vue?vue&type=template&id=e456c0fa&scoped=true"
import script from "./CommandsList.vue?vue&type=script&lang=js"
export * from "./CommandsList.vue?vue&type=script&lang=js"

import "./CommandsList.vue?vue&type=style&index=0&id=e456c0fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e456c0fa"

export default script